import { ApiError, userMessageForError } from "@/lib/errors";
import type { ApiErrorBody } from "@/api/types";

export interface ApiEnvelope<T> {
  message: string;
  data: T;
  meta: {
    success: boolean;
    timestamp?: string;
    request_id?: string;
    http_status?: number;
  };
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function unwrapEnvelope<T>(value: unknown): T {
  if (isRecord(value) && "data" in value && isRecord(value.meta ?? {})) {
    return value.data as T;
  }
  return value as T;
}

export function envelopeErrorBody(value: unknown): ApiErrorBody {
  if (!isRecord(value)) return {};
  const nested = value.error;
  if (isRecord(nested)) {
    return {
      error: typeof nested.message === "string" ? nested.message : undefined,
      code: typeof nested.code === "string" ? nested.code : undefined,
      details: isRecord(nested.details) ? nested.details : undefined,
    };
  }
  return {
    error: typeof value.error === "string" ? value.error : undefined,
    code: typeof value.code === "string" ? value.code : undefined,
  };
}

export function normalizeEnvelopeError(status: number, rawBody: unknown): ApiError {
  const body = envelopeErrorBody(rawBody);
  const message =
    body.error ||
    (isRecord(rawBody) && typeof rawBody.message === "string" ? rawBody.message : "") ||
    userMessageForError(status, body);
  return new ApiError(status, body, message);
}
